module.exports = __webpack_public_path__ + "static/media/clients-02.6893eb64.svg";